import {Winner} from "../../components/Carousels/Carousel";

export const winners24: Winner[] = [
    {
        id: 1,
        team: "Freiburg",
        thumbnail: "https://static.igem.wiki/teams/5295/bfh/24-best-poster-freiburg.webp",
        prize: "Best Booth",
        placement: "Winner",
    },
    {
        id: 2,
        team: "GU-Frankfurt",
        thumbnail: "https://static.igem.wiki/teams/5295/bfh/26-best-poster-frankfurt.webp",
        prize: "Best Booth",
        placement: "Runner-Up",
    },
    {
        id: 3,
        team: " WageningenUR",
        thumbnail: "https://static.igem.wiki/teams/5295/bfh/28-best-poster-wageningen.webp",
        prize: "Best Booth",
        placement: "Third Place",
    },
    {
        id: 4,
        team: "Aachen",
        thumbnail: "https://static.igem.wiki/teams/5247/photos/meetup/aachen.jpeg",
        prize: "Best Presentation",
        placement: "Winner",
    },
    {
        id: 5,
        team: "Marburg",
        thumbnail: "https://static.igem.wiki/teams/5295/bfh/25-best-presentation-marburg.webp",
        prize: "Best Presentation",
        placement: "Runner-Up",
    },
    {
        id: 6,
        team: "GU-Frankfurt",
        thumbnail: "https://static.igem.wiki/teams/5295/bfh/27-best-presentation-frankfurt.webp",
        prize: "Best Presentation",
        placement: "Third Place",
    },
]